<template>
   <v-dialog
   v-model="openDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="title-card">
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.pessoa.id"
                :items="getPessoas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Pessoas"
              ></v-autocomplete>
            </v-col>
            <!--<v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="obj.categoria.id"
                :items="getCategorias"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Categoria"
              ></v-select>
            </v-col>-->
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.empresa.id"
                :items="getEmpresas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Empresas"
              ></v-autocomplete>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.obra.id"
                :items="getObras"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.nfe"
                label="NFE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.data_emissao"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de emissão"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.data_saida"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de pagamento"
                outlined
              ></v-text-field>
            </v-col>
            <!--<v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.data_recibo"
                v-mask="'##/##/####'"
                label="Data do recibo"
                outlined
              ></v-text-field>
            </v-col>-->
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.valor"
                required
                :rules="nameRules"
                label="Valor"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
            <v-text-field
                v-model="obj.pessoaManual"
                required
                label="Descrição manual"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive"
                label="Link GOOGLE DRIVE - NOTA"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_2"
                label="Link GOOGLE DRIVE - NOTA - 2"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_3"
                label="Link GOOGLE DRIVE - NOTA - 3"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante"
                label="Link GOOGLE DRIVE - COMPROVANTE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante_2"
                label="Link GOOGLE DRIVE - COMPROVANTE - 2"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante_3"
                label="Link GOOGLE DRIVE - COMPROVANTE - 3"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive">
              <a :href="obj.link_google_drive" target="_blank">Arquivo - GOOGLE DRIVE - NOTA</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  NOTA</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_2">
              <<a :href="obj.link_google_drive_2" target="_blank">>Arquivo - GOOGLE DRIVE - NOTA - 2</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>ocumento não cadastrado -  NOTA - 2</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_3">
              <a :href="obj.link_google_drive_3" target="_blank">Arquivo - GOOGLE DRIVE - NOTA - 3</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>ocumento não cadastrado -  NOTA - 3</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante">
              <a :href="obj.link_google_drive_comprovante" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante_2">
              <a :href="obj.link_google_drive_comprovante_2" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE - 2</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante - 2</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante_3">
              <a :href="obj.link_google_drive_comprovante_3" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE - 3</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante - 3</span>
            </v-col>
          </v-row>
         </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          dark
          color="primary"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  props:{
        openDialog: Boolean
    },
    data () {
      return {
        valid:false,
        formTitle:'Novo cadastro',
        nameRules: [
          v => !!v || 'Campo requerido',
        ],
        dialog: false,
        obj: {
          empresa: {
            id: null
          },
          obra: {
            id: null
          },
          pessoa: {
            id: null
          },
          categoria: {
            id: null
          },
          nfe: null,
          data_saida:'',
          //data_recibo:'',
          valor:'',
        },
      }
    },
  /* eslint-disable */
    computed: {
      ...mapGetters('empresa', {getEmpresas:'getList'}),
      ...mapGetters('pessoa', {getPessoas:'getList'}),
      ...mapGetters('obra', {getObras:'getList'}),
      //...mapGetters('categoria', {getCategorias:'getList'}),
    },
    methods: {
      ...mapActions('saida', ['saveSaida']),
      async save() {
          this.$refs.form.validate()
          const emailUsuarioLogged = localStorage.getItem("email_logged");
          const noWDate = new Date();
          /* eslint-disable no-console */
          if (this.valid) {
            try {
                await this.saveSaida({
                  ...this.obj,
                  active: true,
                  empresa:{
                    ...this.getEmpresas.find((item) => item.id === this.obj.empresa.id)
                  },
                  obra: {
                    ...this.getObras.find((item) => item.id === this.obj.obra.id)
                  },
                  pessoa: {
                    ...this.getPessoas.find((item) => item.id === this.obj.pessoa.id)
                  },
                  user:{
                    email: emailUsuarioLogged,
                    data: noWDate.toLocaleString()
                  }
                })
            } catch (error) {
                console.error(error);
            } finally {
                this.closeModal();
            }
          }
        },
      closeModal () {
        this.$emit('closeModal')
      },
      reset(){
        this.$refs.form.reset()
      },
  },
  watch:{
      openDialog(){
        this.reset();
      }
    }
}
</script>
